import React,{Fragment} from 'react';
import {deconstructDecimalTime} from '../timeConversion'

const TimeDisplay = ({decimalHours}) => {
    const {hours,minutes,seconds} = deconstructDecimalTime(decimalHours)

    return(
        <Fragment>
            {hours>0 ? hours : ""}<sup className="text-muted">{hours>0 ? "h" : ""}</sup>
            {minutes}<sup className="text-muted">m</sup>
            <span className="text-muted">{seconds}<sup>s</sup></span>
        </Fragment>  
    )

}

export default TimeDisplay